import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/student/notifications`;

export const studentNotificationsRoutesObj = {
  list: baseRoute,
} as const;

export type IStudentNotificationsRouteParams = IExtractRouteParamMap<
  typeof studentNotificationsRoutesObj
>;

export const studentNotificationsPath = createPaths<
  typeof studentNotificationsRoutesObj,
  IStudentNotificationsRouteParams
>(studentNotificationsRoutesObj);
